import { ROUTE_GROUPS, ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

const SETTINGS_QUERY =
	'config=(filter|columns|swimlanes|quickFilters|cardColors|cardLayout|estimation|time|timelineConfig)';

export const rapidboardBacklogSettingsRoute = {
	group: ROUTE_GROUPS.CLASSIC_SOFTWARE,
	name: ROUTE_NAMES.RAPIDBOARD_BACKLOG,
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
	query: [SETTINGS_QUERY],
};

export const rapidboardBoardSettingsRoute = {
	group: ROUTE_GROUPS.CLASSIC_SOFTWARE,
	name: ROUTE_NAMES.RAPIDBOARD_BOARD,
	path: '/jira/software/c/projects/:projectKey/boards/:boardId',
	query: [SETTINGS_QUERY],
};

export const userBoardSettingsRoute = {
	group: ROUTE_GROUPS.CLASSIC_SOFTWARE,
	name: ROUTE_NAMES.RAPIDBOARD_USER_BOARD,
	path: '/jira/people/:accountId/boards/:boardId',
	query: [SETTINGS_QUERY],
};

export const userBacklogSettingsRoute = {
	group: ROUTE_GROUPS.CLASSIC_SOFTWARE,
	name: ROUTE_NAMES.RAPIDBOARD_USER_BACKLOG,
	path: '/jira/people/:accountId/boards/:boardId/backlog',
	query: [SETTINGS_QUERY],
};
